import { useEffect, useState } from "react";

import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";

export const useAllMSA = ({ enabled }) => {
  const { trekService } = services;
  const [data, setData] = useState();

  const { sendRequest: getAllMSA, loading } = useApiRequest(
    () => trekService.getAllMSA().then(setData),
    false,
  );

  useEffect(() => {
    if (enabled && !data) {
      getAllMSA();
    }
  }, [enabled]);

  return { data, loading };
};
